// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@5.2.5_webpack@4.47.0_webpack-cli@4.10.0_/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@5.2.5_webpack@4.47.0_webpack-cli@4.10.0_/node_modules/css-loader/dist/runtime/getUrl.js";
import ___CSS_LOADER_URL_IMPORT_0___ from "./imgs/bg.png";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-modal--topic{z-index:20}.plv-iar-topic{position:fixed;bottom:0;left:0;right:0;z-index:20;background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") 100% 100%;background-size:100% 100%;padding:28px 24px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
